import { Component, OnInit, ElementRef, ViewChild, NgModule } from '@angular/core';
import { Hoarding, ExcelHoarding } from '@app/_services/Instore'; // './././_services/Instore';
import * as XLSX from 'xlsx';
import {Sort} from '@angular/material/sort';
import { ExcelService } from '@app/_services/excel.service';
import * as moment from 'moment'; 
import { first } from 'rxjs/operators';
import { InstoreService} from '@app/_services'; 
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService,IndividualConfig } from 'ngx-toastr';

@Component({
  selector: 'app-bulkhoarding',
  templateUrl: './bulkhoarding.component.html',
  styleUrls: ['./bulkhoarding.component.css']
})
export class BulkhoardingComponent implements OnInit {
  @ViewChild("file") fileInput: ElementRef;

  importHoarding: ExcelHoarding[] = [];
  exportHoarding: Hoarding[] = [];
  filterString = "";

  private format = 'YYYY-MM-DD';

  _hoardingLists: Hoarding[] = [];
  _hoarding_bulk_upload_Lists: Hoarding[] = [];
  _hoarding_bulk_error_error_lists: Hoarding[] = [];

  isLoading = false;
  page = 1;
  pageSize = 15;

  nModule = 1; //1 for Validate, 2 for Upload

  constructor(private excelSrv: ExcelService, private instoreService: InstoreService,private modalService: NgbModal, private toastr: ToastrService) { }

  ngOnInit(): void {
    //this.refreshRecognitions()
  }
  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    this.nModule=1;
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      let data = <any[]>this.excelSrv.importFromFile(bstr);
      data= data.filter(item => !(Array.isArray(item) && item.length === 0));
      const header: string[] = Object.getOwnPropertyNames(new ExcelHoarding());
      const importedData = data.slice(1);

      this.importHoarding = importedData.map(arr => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return <ExcelHoarding>obj;
      })
      this.loadInstoreForDisplay();
      //console.log("onFileChange "+this.importHoarding.length);
      this.fileInput.nativeElement.value = "";
      //console.log("Reports----"+JSON.stringify(this._hoardingLists))

    };
    reader.readAsBinaryString(target.files[0]);

  }


  loadInstoreForDisplay() {
    this._hoardingLists = []

    for(var i=0; i<this.importHoarding.length;i++) {
          var tempImport = this.importHoarding[i];
          let tempInstore = {
            name: tempImport.name, 
            area: tempImport.area, 
            region: tempImport.region,   
            showroom: tempImport.showroom,
            asset_type: tempImport.assets, 
            creative: tempImport.creative, 
            // lat: tempImport.lat,
            // lang: tempImport.long,
            size_w: tempImport.width,
            size_h: tempImport.height,
            cost: parseInt(tempImport.cost),
            asset_count: "",
            install_date: this.dateConversion(tempImport.installation_date),
            expiry_date: this.dateConversion(tempImport.expiry_date),
            particulars: tempImport.particulars,
            image: tempImport.image,
            vendor: tempImport.vendor,
            address: tempImport.address,
          };   

          //console.log("loadInstoreForDisplay "+tempInstore.particulars)

          this._hoardingLists.push(tempInstore);
    }
  }
  public dateConversion(date){
    return moment(date, 'yyyy-MM-dd').add(1, 'hours').format(this.format)
   }
  
  excelDateToJSDate(excelDate) {
    var date = new Date(Math.round((excelDate - (25567 + 1)) * 86400 * 1000));
    var converted_date = date.toISOString().split('T')[0];
    return converted_date;
  }


  submitText() {
    if(this.nModule == 1) {
      return "Validate";
    } else {
      return "Upload";
    }
  }

  submitButtonClicked(modalID) {
    if(this.nModule == 1) {
      this.validateHoarding(); 
    } else {
      this.uploadHoarding(modalID);
    }
  }


  localeValidation() {
    var isStopService = false;
    var emptyRegion = this._hoardingLists.filter(function (e) {return e.region == null || e.region == "";});  
    if(emptyRegion.length > 0) { isStopService = true; this.toastr.warning("Region could not be empty", "Warning", {timeOut: 10000}); }

    var emptyShowroom = this._hoardingLists.filter(function (e) {return e.showroom == null || e.showroom == "";}); 
    if(emptyShowroom.length > 0) { isStopService = true; this.toastr.warning("Showroom could not be empty", "Warning", {timeOut: 10000}); }

    var emptyArea = this._hoardingLists.filter(function (e) {return e.address == null || e.address == "";}); 
    if(emptyArea.length > 0) { isStopService = true; this.toastr.warning("Area could not be empty", "Warning", {timeOut: 10000}); }

    var emptyType= this._hoardingLists.filter(function (e) {return e.asset_type == null || e.asset_type == "";}); 
    if(emptyType.length > 0) { isStopService = true; this.toastr.warning("Asset type could not be empty", "Warning", {timeOut: 10000}); }

    var emptyCreatives = this._hoardingLists.filter(function (e) {return e.creative == null || e.creative == "";}); 
    if(emptyCreatives.length > 0) { isStopService = true; this.toastr.warning("Creative could not be empty", "Warning", {timeOut: 10000}); }

    var emptyParticular = this._hoardingLists.filter(function (e) {return e.particulars == null || e.particulars == "";}); 
    if(emptyParticular.length > 0) { isStopService = true; this.toastr.warning("Particulars could not be empty", "Warning", {timeOut: 10000}); }

    var emptyWidth = this._hoardingLists.filter(function (e) {return e.size_w == null || e.size_w == "";}); 
    if(emptyWidth.length > 0) { isStopService = true; this.toastr.warning("Size width could not be empty", "Warning", {timeOut: 10000}); }

    var emptyHeight = this._hoardingLists.filter(function (e) {return e.size_h == null || e.size_h == "";}); 
    if(emptyHeight.length > 0) { isStopService = true; this.toastr.warning("Size height could not be empty", "Warning", {timeOut: 10000}); }

    var emptyCost = this._hoardingLists.filter(function (e) {return e.cost == null;}); 
    if(emptyCost.length > 0) { isStopService = true; this.toastr.warning("Cost could not be empty", "Warning", {timeOut: 10000}); }     

    var emptyName = this._hoardingLists.filter(function (e) {return e.name == null || e.name == "";}); 
    if(emptyName.length > 0) { isStopService = true; this.toastr.warning("Instore name could not be empty", "Warning", {timeOut: 10000}); }

    var emptyVendor = this._hoardingLists.filter(function (e) {return e.vendor == null || e.vendor == "";}); 
    if(emptyVendor.length > 0) { isStopService = true; this.toastr.warning("Vendor could not be empty", "Warning", {timeOut: 10000}); }

    var emptyInstallation = this._hoardingLists.filter(function (e) {return e.install_date == null || e.install_date == "";}); 
    if(emptyInstallation.length > 0) { isStopService = true; this.toastr.warning("Installation date could not be empty", "Warning", {timeOut: 10000}); }

    var emptyExpiry = this._hoardingLists.filter(function (e) {return e.expiry_date == null || e.expiry_date == "";}); 
    if(emptyExpiry.length > 0) { isStopService = true; this.toastr.warning("Expiry date could not be empty", "Warning", {timeOut: 10000}); }
    return isStopService;                                                                 
  }


  validateHoarding() {
    if(this.localeValidation()) {
      return;
    }

    let tempMessage = {
      type: "validate",
      hoardingdata: this._hoardingLists
    }

    //console.log("Reports----"+JSON.stringify(tempMessage))
    
    this.instoreService.validateBulkHoarding(JSON.stringify(tempMessage))
    .pipe(first())
      .subscribe(
      (response) => {
        //console.log("validateHoarding Resposne "+JSON.stringify(response));
        this._hoardingLists = response.results;
        this.checkForApprovedInstore();
      },
      (error) => {     
        //console.log("validateHoarding Error "+error);                          
      }
    );

  }

  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
      // var str = value.toString();
      // var numarray = str.split('.');
      // var a = new Array();
      // a = numarray;
      // console.log(a[0]+"------"+a[1])

      // if(a[1] ==0 || a[1] == null|| a[1] == ''|| a[1] ==undefined){
      //   return a[0]+"'";
      // }else{
      //   a[1] = a[1].slice(0, 2);
      //   return a[0] +"' "+ a[1]+"\"";
      // }
    }
  }


  checkForApprovedInstore() {
    this._hoarding_bulk_upload_Lists = []

    for(var i=0; i<this._hoardingLists.length;i++) {
      var tempImport = this._hoardingLists[i];
      if(this.checkForGreen(tempImport)) {
            let squarefeet = parseInt(tempImport.size_w) * parseInt(tempImport.size_h);

            let tempInstore = {
              name: tempImport.name, 
              address: tempImport.address,
              area: tempImport.area,
              region: tempImport.region,   
              showroom: tempImport.showroom,
              asset_type: tempImport.asset_type, 
              creative: tempImport.creative, 
              // lat: tempImport.lat,
              // lang: tempImport.lang,      
              size_w: tempImport.size_w,
              size_h: tempImport.size_h,
              square_feet: squarefeet,
              install_date: tempImport.install_date,
              expiry_date: tempImport.expiry_date,
              particulars: tempImport.particulars,
              image: tempImport.image,
              vendor: tempImport.vendor,
              cost: tempImport.cost ,
              region_id: tempImport.region_id,
              showroom_id: tempImport.showroom_id,
              asset_type_id: tempImport.asset_type_id,
              creative_id: tempImport.creative_id,
              vendor_id: tempImport.vendor_id
            };   

            this._hoarding_bulk_upload_Lists.push(tempInstore);
      }else{
            this._hoarding_bulk_error_error_lists.push(tempImport);
      }
    }

    if(this._hoarding_bulk_upload_Lists.length > 0 && this._hoarding_bulk_error_error_lists.length==0) {
      this.nModule = 2;
    }
    if(this._hoarding_bulk_error_error_lists.length>0){
      this.excelSrv.exportAsExcelFile_( this._hoarding_bulk_error_error_lists, 'error_hoarding_data');
    }
  }

  uploadHoarding(modalID) {
    this.isLoading = true;
    let tempMessage = {
      type: "import",
      hoardingdata: this._hoarding_bulk_upload_Lists
    }

    //console.log("Reports----"+JSON.stringify(tempMessage))
    
    this.instoreService.uploadBulkHoarding(JSON.stringify(tempMessage))
    .pipe(first())
      .subscribe(
      (response) => {
       // console.log("uploadBulkHoarding Resposne "+response.state);
        //this.displayInstores = response.results;
        this.nModule = 1;
        this._hoardingLists = [];
        this.isLoading = false;
        this.openModal(modalID);
      },
      (error) => {     
        console.log("uploadBulkHoarding Error "+error);   
        this.isLoading = false;                       
      }
    );

  }

  checkForGreen(instore: Hoarding) {
    if( (parseInt(instore.region_id) > 0) && (parseInt(instore.showroom_id) > 0) && (parseInt(instore.asset_type_id) > 0) && (parseInt(instore.creative_id) > 0) && (parseInt(instore.vendor_id) > 0) && (parseInt(instore.id) == 0)) {
      return true;
    } else {
      return false;
    }

  }


  exportData(tableId: string) {
    this.excelSrv.exportToFile("instore", tableId);
  }
  closeResult :string
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}